/**
 * Classes that turn a <DialogContent> into a full-screen page on phones
 * (below the `md` breakpoint, the same one `useIsMobile()` switches on). The
 * desktop classes of the dialog stay in effect from `md:` up.
 *
 * `content-start` is needed because <DialogContent> is a CSS grid: with the
 * full viewport height its rows would otherwise spread over the screen.
 */
export const fullScreenOnMobile =
  "max-md:top-0 max-md:h-dvh max-md:max-h-none max-md:w-screen max-md:max-w-none! max-md:translate-y-0 max-md:rounded-none max-md:border-0 max-md:overflow-y-auto max-md:content-start";
